@if (isEnabled) {
    <div class="TotemApp" (click)="wsSendActivity()">
        <a class="TotemApp-SkipLink" href="#totem-main-content">{{ 'totem-a11y.skip-to-content' | locTranslate }}</a>
        @if (!isUnderMaintenance()) {
            @if (isLoading || isSwitchingLanguage) {
                <app-pg-loading [isLarge]="true" [isOverlay]="true"></app-pg-loading>
            }
            <div class="TotemApp-Inner">
                @if (!isLoading && !isSwitchingLanguage) {
                    <main id="totem-main-content" class="TotemApp-Inner-Content" tabindex="-1">
                        <router-outlet></router-outlet>
                    </main>
                }
            </div>
            <!-- PARTI COMMENTATE DA RIATTIVARE PER VERSIONE SU TELEFONO -->
            <!--<app-pg-footer></app-pg-footer> -->
        }
        <app-pg-maintenance></app-pg-maintenance>
        @if (appMode == 'web') {
            <app-pg-cookie-consent></app-pg-cookie-consent>
        }
        <!-- TODO: riattivare per gestione errori
        <div [hidden]="!hasErrors()" class="mb-2">
            <app-pg-errors #errorsComponent></app-pg-errors>
        </div>
        -->
    </div>
}
